import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import { catchError, first, mergeMap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { GeoPosActionService } from '../core/geographicalpos/geographicalpos.action';
import { Observable, of } from 'rxjs';
import { Poi } from '../core/poi/poi.model';
import { PoiActionService } from '../core/poi/poi.action';
import { select } from '@angular-redux/store';
import { GeoPos } from '../core/geographicalpos/geographicalpos.model';

@Injectable()
export class PoisForMapResolver implements Resolve<Poi[]> {
  geoposNames = {
    cimbri: 'Cimbri dell\'Altopiano dei Sette Comuni',
    friuli: 'Friulani in Veneto',
    'italiani-in-slovenia': 'Italiani in Slovenia',
    ladini: 'Ladini del Comelico',
    'sloveni-in-italia': 'Sloveni in Italia',
    'friuli-fvg': 'Friulani in Friuli Venezia Giulia'
    
  };
  @select(['geopos', 'list'])
  geoposList$: Observable<GeoPos[]>;
  singleGeopos: GeoPos;
  isGeoposInRedux = false;

  constructor(private service: ApiService,
              private poiAction: PoiActionService,
              private geoposAction: GeoPosActionService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.geoposList$.pipe(
      first(),
      mergeMap((list) => {
        if (list.length > 0) {
          this.isGeoposInRedux = true;
          return of(list);
        }
        return this.service.getGeoPos().pipe(first());
      }),
      mergeMap((list: any) => {
        let geoposList;
        if (this.isGeoposInRedux) {
          geoposList = [...list];
        } else {
          geoposList = GeoPos.fromArray(list);
          this.geoposAction.geoposList(geoposList);
        }

        const nameFromUrl = state.url.split('/').pop();
        this.singleGeopos = geoposList.filter((geopos) =>
          geopos.name.it.includes(this.geoposNames[nameFromUrl]))[0];

        return this.service.getPoisForMap(this.singleGeopos.id);
      }),
      catchError((err) => {
        console.error('Non è stato possibile recuperare la lista di POI di una singola area');
        return of(err);
      })
    );
  }
}
